var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24329",
    "data-name": "Group 24329",
    transform: "translate(-1021 -1025)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12914",
    "data-name": "Rectangle 12914",
    width: 12,
    height: 12,
    transform: "translate(1021 1025)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_001-telephone",
    "data-name": "001-telephone",
    transform: "translate(1022.157 1026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11982",
    "data-name": "Group 11982",
    transform: "translate(0.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3918",
    "data-name": "Path 3918",
    d: "M7.363,51.61a.678.678,0,0,0-1.025,0c-.24.238-.479.475-.715.717a.141.141,0,0,1-.2.036c-.155-.085-.32-.153-.469-.246a7.435,7.435,0,0,1-1.792-1.631,4.246,4.246,0,0,1-.642-1.029.147.147,0,0,1,.036-.189c.24-.232.473-.469.709-.707a.681.681,0,0,0,0-1.049c-.187-.189-.375-.375-.562-.564s-.385-.389-.58-.58a.682.682,0,0,0-1.025,0c-.242.238-.473.481-.719.715a1.167,1.167,0,0,0-.367.787,3.336,3.336,0,0,0,.258,1.436,8.725,8.725,0,0,0,1.549,2.58,9.583,9.583,0,0,0,3.174,2.483,4.59,4.59,0,0,0,1.758.512,1.288,1.288,0,0,0,1.106-.421c.205-.23.437-.439.654-.659a.685.685,0,0,0,0-1.043Q7.941,52.183,7.363,51.61Z",
    transform: "translate(-0.006 -45.208)",
    fill: "#00101a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3919",
    "data-name": "Path 3919",
    d: "M240.037,98.864l.743-.127A3.336,3.336,0,0,0,237.959,96l-.1.747a2.578,2.578,0,0,1,2.183,2.117Z",
    transform: "translate(-233.064 -94.067)",
    fill: "#00101a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3920",
    "data-name": "Path 3920",
    d: "M246,1.567A5.479,5.479,0,0,0,242.859,0l-.1.747A4.781,4.781,0,0,1,246.8,4.668l.743-.127A5.519,5.519,0,0,0,246,1.567Z",
    transform: "translate(-237.865)",
    fill: "#00101a"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b0f48c8e459e8283280183bc68fe57c3.svg";
export { ForwardRef as ReactComponent };